import SmallCTA from './SmallCTA';

export default SmallCTA;
